module.exports = __webpack_public_path__ + "bg.jpg?c0037d423f466e2d549389b2e4731d6f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg.jpg
// module id = 53
// module chunks = 0